import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import './PadSummary.scss';
import stores from '../../../models/Stores';
import { PadSummaryVM } from './PadSummaryVM';
import { Table } from 'reactstrap';
import { Notification } from '../../common/Notification/Notification';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { DesignSummaryButtons } from 'cd-eft/components/Design/common/DesignSummaryButtons';
import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';


const { padDesignStore, designStore } = stores.AppStore;

const PadSummaryComponent = (props) => {
  const vm = useRef(new PadSummaryVM(props)).current;

  useEffect(() => {
    vm.getDesignElements();
  }, [designStore.currentSurface.surfaceDefId]);

  return (
    <div className="pad-summary">
      {vm.error && vm.errorMsg ? (
        <div className="mt-3 err error-message">
          <h3 className="usa-error-message" id="client--message" role="alert">
            {vm.errorMsg}
          </h3>
        </div>
      ) : null}

      {!vm.error && !vm.errorMsg ? (
        <div className="design-summary-table">
          <Table className="set-table">
            <thead>
              <tr>
                <th className="narrow-td">Select</th>
                <th>Id</th>
                <th>Name</th>
                <th>Design Type</th>
                <th className="narrow-td">Actions</th>
              </tr>
            </thead>
            <tbody>
              {padDesignStore.padSummaryTable.map((item: any, i) => {
                return i < padDesignStore.padSummaryTable.length ? (
                  <tr key={'key' + item.designElementId}>
                    <td className="text-center">
                      <input
                        id={'key' + item.designElementId}
                        data-testid="selectDesignElementId"
                        name="keySelect"
                        type="checkbox"
                        aria-label={
                          'id: ' +
                          item.designElementId +
                          ', name: ' +
                          item.designElementName +
                          ' , design type: ' +
                          item.designElementTypeId?.name
                        }
                        value={item.id}
                        checked={item.checked}
                        onChange={(event) => {
                          vm.handleCheckboxChange(event, i, true);
                        }}
                      />
                    </td>
                    <td>{item.designElementId}</td>
                    <td>{item.designElementName}</td>
                    <td>
                      <div className="design-type"> {item.designElementTypeId?.name}
                        {item.flagUpToDate && (
                          <div className="flag-up-todate"><span className="warning-span"> (Invalid) </span>
                            <div className="hover-text"><Icon path={mdiAlertCircleOutline} color="#ac2e36" size={1.2} />
                              <span className="tooltip-text" id="bottom">The structure is no longer valid because the base surface/survey has changed</span>
                            </div></div>
                        )}</div>
                    </td>
                    <td>
                      <ActionsMenu i={i} item={item} elementActions={vm.elementActions} />
                    </td>
                  </tr>
                ) : null;
              })}
            </tbody>
          </Table>
          {padDesignStore.padSummaryTable.length === 0 && !padDesignStore.showLoader && !designStore.isLoading ? (
            <div className="h4 m-5 text-center">Add your first Pad</div>
          ) : null}
        </div>
      ) : null}
      <DesignSummaryButtons
        panel="Pad"
        disableAdd={false}
        disableRefreshElements={vm.jobExecuting || padDesignStore.padSummaryTable.length === 0}
        disableRebuildSurface={vm.jobExecuting || padDesignStore.padSummaryTable.length === 0}
        buttontype={vm.displayType === 'displaypads'}
        add={() => {
          padDesignStore.showLoader = true;
          padDesignStore.currentTab = 'New Pad';
          padDesignStore.hasDesign = true;
          designStore.onNewStructureTab = true;
        }}
        refreshElements={() => {
          vm.displaySelectedPad();
        }}
        rebuildSurface={() => vm.onClickSurface()}
      />
      <Notification
        type={vm.notification.type}
        message={vm.notification.message}
        header={vm.notification.header}
        hidden={vm.notification.hidden}
        timestamp={vm.notification.timestamp}
      />
    </div>
  );
};

export const PadSummary = observer(PadSummaryComponent);
